<template>
  <Head title="Client List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <client-list :client-list="clientList" :num_clients="num_clients"></client-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import ClientList from '../../components/admin/ClientList.vue';

defineProps({
  clientList: Array,
  num_clients: Number
});
</script>

